import { BarChartOutlined, LinkOutlined, SettingOutlined } from '@ant-design/icons';

const modules = [
  {
    name: "Monitoring & Evaluation",
    path: "/app/pme",
    id: "PME-MODULE",
    code: "PME",
    active: true,
    isActive: (user) => {
      if (user.modules.pme) {
        if (user.modules.pme.status === 'pending') {
          return false;
        }

        return true;
      }

      return false;
    },
    icon: BarChartOutlined,
    iconProps: {
      style: {
        color: '#DF606F',
        backgroundColor: '#f5d0d4',
        sidenavBg: '#402f40',
      },
    },
    description: "Consolidated information management turns local mining and mineral trade data into actionable insight.",
    img: '/assets/images/SVG/PME.svg'
  },
  {
    name: "Supply Chain Due Diligence",
    path: "/app/cadd",
    id: "CADD-MODULE",
    code: "CADD",
    active: true,
    isActive: (user) => {
      if (user.modules.cadd) {
        if (user.modules.cadd.status === 'pending') {
          return false;
        }

        return true;
      }

      return false;
    },
    icon: LinkOutlined,
    iconProps: {
      style: {
        color: '#58B99D',
        backgroundColor: '#cdeae2',
      },
    },
    description: "Standardised reporting by all stakeholders, to assess the compliance of mineral supply chains with international standards.",
    img: '/assets/images/SVG/CADD.svg',
  },
  {
    name: "IMS-SIF",
    active: true,
    path: "/app/tif",
    id: "TIF-MODULE",
    code: "TIF",
    icon: SettingOutlined,
    iconProps: {
      style: {
        color: '#d48806',
        backgroundColor: '#fffbe6',
        sidenavBg: '#fffbe6',
      },
    },
    isActive: (user) => {
      return user && user.modules && user.modules.tif ? true : false;
    },
    description: "Submit any query to gain crowdsourced wisdom from hard-to-reach territories."
  },
  {
    name: "TAZAMA",
    active: true,
    path: "/app/tazama",
    id: "TAZAMA-MODULE",
    code: "TAZAMA",
    icon: SettingOutlined,
    iconProps: {
      style: {
        color: '#d48806',
        backgroundColor: '#fffbe6',
        sidenavBg: '#fffbe6',
      },
    },
    isActive: (user) => {
      return user && user.modules && user.modules.tazama ? true : false;
    },
    description: "Submit any query to gain crowdsourced wisdom from hard-to-reach territories."
  },
  // {
  //   name: "Local Investment",
  //   path: "li",
  //   id: "LI-MODULE",
  //   code: "LI",
  //   active: false,
  //   isActive: (user) => {
  //     return user && user.modules && user.modules.li ? true : false;
  //   },
  //   icon: ScheduleOutlined,
  //   description: "Verified data to manage risk and evaluate opportunities all around the globe. No travel necessary."
  // },
  // {
  //   name: "Community Feedback",
  //   path: "cf",
  //   id: "CF-MODULE",
  //   code: "CF",
  //   active: false,
  //   isActive: (user) => {
  //     return user && user.modules && user.modules.cf ? true : false;
  //   },
  //   icon: IdcardOutlined,
  //   description: "Disintermediated impact measurement, turning evaluation costs into a source of income for local stakeholders."
  // },
  // {
  //   name: "SDG Performance",
  //   path: "sdgm",
  //   id: "SDGM-MODULE",
  //   code: "SDGM",
  //   active: false,
  //   isActive: (user) => {
  //     return user && user.modules && user.modules.sdgm ? true : false;
  //   },
  //   icon: GlobalOutlined,
  //   description: "A reliable measure of your company’s contribution to the UN Sustainable Development Goals."
  // },
];

export const getModules = (values) => {
  return modules.filter(t => values.map(v => v.toUpperCase()).includes(t.code)) || []
}
export const getModulesValues = (values) => {
  const data = getModules(values);
  return data.map(d => d.code);
}
export const getModulesNames = (values) => {
  const data = getModules(values);
  return data.map(d => d.name);
}
export const getModulesNamesTranslated = (values, t) => {
  const data = getModules(values);
  return data.map(d => t(d.name));
}
export default modules

export const modulesColors = {
  CADD: 'green',
  PME: 'red',
};


export const getAppFromModule = (mod, appsConfig = []) => {
  return appsConfig.find((c) => c.modules.includes(mod));
}
